<template>
  <div>
     <router-view/> 
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {

  },
  data(){
    return{
         
    }
  },
  created(){
    this.getData() 
  },
  methods:{
      getData(){
      }
  }
}
</script>
<style>
   *{
     margin:0;
     padding:0;
    }
    .common-items-center {
      display:flex;
      align-items:center;
    }
    .common-space-around {
      display:flex;
      justify-content: space-around;
    }
  
    .common-space-between {
      display:flex;
      justify-content: space-between;
    }
    .common-display{
      display: flex;
    } 

    .common-width{
        width:1200px
    }
    /* 添加自定义滚动条样式 */
    body::-webkit-scrollbar {
      width: 0.5em;
      display: none;
    }

    body::-webkit-scrollbar-thumb {
      background-color: #888; /* 滚动条滑块颜色 */
    }

    body::-webkit-scrollbar-track {
      background: transparent; /* 滚动条轨道颜色 */
    }
    .common-border{
      border: 1px solid rgba(0,0,0,.1);
      padding: 10px;
      border-radius: 10px;
    }
    img{
      display:block;
    }
    /* 常规 */
    /* @font-face {
      font-family: 'Alibaba_Regular';
      src: url('../src/assets/font/Alibaba_Regular.ttf');
    } */
    /* 中等 */
    /* @font-face {
      font-family: 'Alibaba_Midum';
      src: url('../src/assets/font/Alibaba_midum.ttf');
    } */
    /* 粗体 */
    /* @font-face {
      font-family: 'Alibaba_Bold';
      src: url('../src/assets/font/Alibaba_Bold.ttf');
    } */
    /* @font-face {
      font-family: 'Helvetica';
      src: url('../src/assets/font/Helvetica.ttf');
    } */
    /* @font-face {
      font-family: 'gilroy-bold';
      src: url('../src/assets/font/gilroy-bold-4.otf');
    } */
</style>


